import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

/** Menu mobile des portails (< 1024 px) : barre supérieure + bouton ; la sidebar se replie et se referme à chaque navigation. */
export function useMobileMenu() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(false); }, [pathname]);
  const onNavClick = (e) => { if (e.target.closest && e.target.closest("a, button[data-nav]")) setOpen(false); };
  return { open, toggle: () => setOpen((o) => !o), onNavClick, asideClass: `${open ? "flex" : "hidden"} lg:flex` };
}

export function MobileTopBar({ portal, label, open, onToggle, dark = false, accent }) {
  const testid = `${portal}-mobile`;
  return (
    <div className={`lg:hidden flex items-center justify-between px-4 h-14 border-b sticky top-0 z-30 ${dark ? "bg-[#0A0A0A] text-white border-white/10" : "bg-white border-[#DEE2E6]"}`} data-testid={`${testid}-bar`}>
      <Link to="/" className="flex items-center gap-2">
        <img src="/pag-logo.png" alt="PAG" className={`h-8 w-8 object-contain ${dark ? "bg-white p-0.5" : ""}`} />
        <span className="font-display font-black">PAG</span>
        <span className={`text-[10px] uppercase tracking-[0.25em] border-l pl-2 ${dark ? "border-white/20" : "border-[#DEE2E6]"}`} style={{ color: accent || (dark ? "rgba(255,255,255,0.6)" : "#868E96") }}>{label}</span>
      </Link>
      <button type="button" onClick={onToggle} aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} aria-expanded={open} data-testid={`${testid}-menu`}
        className={`h-10 w-10 inline-flex items-center justify-center border ${dark ? "border-white/20 hover:border-white" : "border-[#DEE2E6] hover:border-[#0A0A0A]"}`}>
        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
      </button>
    </div>
  );
}
